import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  DatePickerWrapper,
  TimePickerWrapper,
  Wrapper,
} from './DatePicker.styles';
import { Time } from '../../molecules/TimePicker/types';
import { DatePicker, TimePicker } from '../../molecules';

export type DateTimePickerProps = {
  /**
   * Component change event handler
   */
  onChange: (date: Dayjs) => void;
  /**
   * Modal container - can be used handle outside click
   */
  modalRef?: React.RefObject<HTMLElement>;
  /**
   * Portal container used to mount options component
   */
  portalContainer?: React.RefObject<HTMLElement>;
  /**
   * Initial date
   */
  initialDate?: string;
  /**
   * DateTime picker disabled state
   */
  disabled?: boolean;
  /**
   * Minimum date that the user can select
   */
  minDate?: Date;
  /**
   * Maximum date that the user can select
   */
  maxDate?: Date;
};

export const DateTimePicker = ({
  onChange,
  modalRef,
  portalContainer,
  initialDate,
  disabled,
  minDate,
  maxDate,
}: DateTimePickerProps) => {
  const initialDateTime = dayjs(initialDate);

  const [time, setTime] = useState({
    minute: initialDateTime.minute(),
    hour: initialDateTime.hour(),
  });

  const [date, setDate] = useState(initialDateTime.toDate());

  const onDateValueChange = (date: Date) => {
    setDate(date);
    const parsedDate = dayjs(date).hour(time.hour).minute(time.minute);
    onChange(parsedDate);
  };

  const onTimeValueChange = (time: Time) => {
    setTime(time);
    const parsedDate = dayjs(date).hour(time.hour).minute(time.minute);
    onChange(parsedDate);
  };

  return (
    <Wrapper>
      <TimePickerWrapper>
        <TimePicker
          onChange={(time) => onTimeValueChange(time)}
          value={time}
          portalContainer={portalContainer}
          modalRef={modalRef}
          disabled={disabled}
        />
      </TimePickerWrapper>
      <DatePickerWrapper>
        <DatePicker
          onChange={(date) => onDateValueChange(date)}
          value={date}
          portalContainer={portalContainer}
          modalRef={modalRef}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
      </DatePickerWrapper>
    </Wrapper>
  );
};
